function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnreadEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.047,
    height: 13,
    viewBox: "0 0 16.047 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.03 8.742a2.15 2.15 0 1 0-2.15-2.15 2.167 2.167 0 0 0 2.15 2.15zm-10.847 7.7h10.05a1.761 1.761 0 0 0 1.882-2.019V9.415a2.52 2.52 0 0 1-1.14.193v4.71l-3.391-3.358 1.838-1.807a2.713 2.713 0 0 1-.773-.71l-2.8 2.76a1.013 1.013 0 0 1-.716.368 1.024 1.024 0 0 1-.717-.368l-4.548-4.5a1.6 1.6 0 0 1 .312-.031h7.832a2.514 2.514 0 0 1 .188-1.157H6.027A1.767 1.767 0 0 0 4.139 7.54v6.885a1.807 1.807 0 0 0 2.043 2.018zm-.9-8.829 3.4 3.346-3.4 3.371zm5.85 5.059a1.888 1.888 0 0 0 1.352-.629l.343-.343 3.576 3.545a1.13 1.13 0 0 1-.336.044H6.182a1.323 1.323 0 0 1-.324-.037L9.441 11.7l.343.343a1.888 1.888 0 0 0 1.352.631z",
    transform: "translate(-3.639 -3.943)",
    style: {
      fill: "currentColor",
      stroke: "transparent",
      strokeMiterlimit: 10
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadEmail);
export default __webpack_public_path__ + "static/media/unread_email.0a5dbc85.svg";
export { ForwardRef as ReactComponent };